module.exports = __webpack_public_path__ + "static/media/manageEmployeesIcon.647d78ce.svg";